import _ from 'lodash'
import uid from 'uid'
import router from '../../router'
import api from '../../api'
import campaign from '../../api/campaign'

export const campaignTypesEnum = {
  DEMOGRAPHY_50: 'Demography - 50 resp',
  DEMOGRAPHY_100: 'Demography - 100 resp',
  DEMAND_QUANT_MY_PRODS_50: "Demand (quantitative) - My products 50 resp",
  DEMAND_QUANT_MY_PRODS_100: "Demand (quantitative) - My products - 100 resp",
  DEMAND_QUANT_ALL_PRODS_50: "Demand (quantitative) - All products - 50 resp",
  DEMAND_QUANT_ALL_PRODS_100: "Demand (quantitative) - All products - 100 resp",
  DEMAND_QUALITATIVE: "Demand (qualitative) - All products - 1 resp",
  SOLD_PRODUCTS: "Sold products - All products - All teams",
  AD_TYPES_MY_50: "Mediatypes effectivity - My Ads - 50 ads",
  AD_TYPES_MY_100: "Mediatypes effectivity - My Ads -100 ads",
  AD_TYPES_ALL_50: "Mediatypes effectivity - All Ads - 50 ads",
  AD_TYPES_ALL_100: "Mediatypes effectivity - All Ads - 50 ads",
}

const withComputedPrice = (getters) => (campaigns) => (
  campaigns.map(campaing => {
    const adType = getters.gameAdTypes.find(adType => adType.id === campaing.adTypeId)
    let computedPrice = adType.price * campaing.dayTimes.length * campaing.locationIds.length

    return {
      ...campaing,
      computedPrice
    }
  })
)

export const groupCampaigns = (getters) => (source, archived = false) => {
  const groups = _.groupBy(source, item => item.productId)
  const products = getters.teamProducts
  const campaigns = []
  _.forEach(groups, (group, id) => {
    _.forEach(_.groupBy(group, item => item.turn), (items, turn) => {
      const isTemp = !_.find(items, campaign => !campaign.isTemp)
      const product = products.find(product => product.id === parseInt(id))
      campaigns.push({
        items,
        isTemp,
        product,
        orderBy: isTemp
          ? _.minBy(items, campaign => campaign.createdAt).createdAt
          : archived ? parseInt(turn) : _.minBy(items, campaign => campaign.id).id,
        turn: parseInt(turn),
        totalPrice: items.reduce((acc, curr) => {
          return acc + (curr.computedPrice || curr.price)
        }, 0),
      })
    })
  })
  return _.orderBy(campaigns, 'orderBy', [archived ? 'desc' : 'asc'])
}

const defaultState = () => ({
  campaigns: [],
  allGameCampaigns: [],
  tempCampaigns: [],
  archivedCampaigns: [],
})

export default {
  defaultState,
  state: defaultState,
  getters: {
    teamCampaigns: (state, getters) => withComputedPrice(getters)(state.campaigns),
    allGameCampaigns: state => state.allGameCampaigns,
    tempCampaigns: (state, getters) => withComputedPrice(getters)(state.tempCampaigns),
    teamArchivedCampaigns: state => state.archivedCampaigns,
    groupedCampaigns: (state, getters) => groupCampaigns(getters)([...getters.teamCampaigns, ...getters.tempCampaigns]),
    groupedArchivedCampaigns: (state, getters) => groupCampaigns(getters)(getters.teamArchivedCampaigns, true),
    groupedCampaignsOverview: (state, getters) => groupCampaigns(getters)([...getters.teamCampaigns, ...getters.teamArchivedCampaigns]),
  },
  actions: {
    addTempCampaign({ commit, getters }, productId = null) {
      commit('ADD_CAMPAIGN', {
        id: uid(),
        isTemp: true,
        productId: productId ? productId : getters.productsWithoutCampaign[0].id,
        adTypeId: getters.gameAdTypes[0].id,
        dayTimes: [],
        locationIds: [],
        turn: getters.activeGame.turn,
        price: 0,
        createdAt: new Date(),
      })
    },
    async deleteCampaign({ commit, dispatch }, campaign) {
      if (campaign.isTemp) {
        commit('DELETE_TEMP_CAMPAIGN', campaign.id)
      } else {
        dispatch('toggleLoader', true)
        try {
          await api.campaign.delete(campaign.id)
        } catch (e) {
          this.$toast.error('Something went wrong!');
        }
        dispatch('toggleLoader', false)
      }
    },

    async lockCampaign({ commit, dispatch }, campaignId) {
      try {
        await api.campaign.lock(campaignId)
      } catch (e) {
        this.$toast.error('Something went wrong!');
      }
    },
    async unlockCampaign({ commit, dispatch }, campaignId) {
      try {
        await api.campaign.unlock(campaignId)
        commit('UNLOCK_CAMPAIGN', campaignId);
      } catch (e) {
        this.$toast.error('Something went wrong!');
      }
    },
    async deleteCampaigns({ commit, dispatch, getters }, productId) {
      const campaigns = [...getters.teamCampaigns, ...getters.tempCampaigns].filter(campaign => campaign.productId === productId)
      if (campaigns.length) {
        dispatch('toggleLoader', true)
        for (let i = 0; i < campaigns.length; i++) {
          await dispatch('deleteCampaign', campaigns[i])
        }
        dispatch('toggleLoader', false)
      }
    },
    async fetchCampaigns({ commit, getters }) {
      const team = getters.myTeam
      if (team) {
        try {
          const { data: current } = await api.campaign.findAllCurrentByTeamId(team.id)
          const { data: archived } = await api.campaign.findAllArchivedByTeamId(team.id)
          commit('SET_CAMPAIGNS', current)
          commit('SET_ARCHIVED_CAMPAIGNS', archived.map(campaign => ({ ...campaign, archived: true })))
        } catch (e) {
          //this.$toast.error('Something went wrong!');
        }
      }
    },
    async fetchGameCampaigns({commit, getters}) {
      const id = getters.currentGameId;
      if (id) {
        try {
          const { data } = await api.campaign.findAllCurrentByGameId(id);

          const groupedTeams = _.groupBy([...data], item => item.teamId)
          const allTeamsData = []
          _.forOwn(groupedTeams, dataRows => {
            let sorted = dataRows.sort((a, b) => {if (a.teamId > b.teamId) {return 1} else if (a.teamId === b.teamId) {return 0} else return -1});
            if (sorted[0]) {
              allTeamsData.push({
                id: sorted[0].teamId,
                name: getters.gameAllTeams.find(team => team.id === sorted[0].teamId).name,
                results: sorted,
              })
            }
          });
          commit('SET_ALL_GAME_CAMPAIGNS', allTeamsData)
        } catch (e) {
          this.$toast.error('Something went wrong!');
        }
      }
    },
    async saveCampaign({ commit, dispatch }, campaign) {
      dispatch('toggleLoader', true)
      try {
        if (campaign.isTemp) {
          const { data } = await api.campaign.purchase(campaign)
          commit('DELETE_TEMP_CAMPAIGN', campaign.id)
          commit('ADD_CAMPAIGN', data)
        } else {
          await api.campaign.update(campaign)
        }
        this.$toast.success(`Campaign has been purchased!`, { timeout: 1500 });
      } catch (e) {
        this.showError(e)
      }
      dispatch('toggleLoader', false)
    },
    updateCampaign({ commit }, campaign) {
      commit('UPDATE_CAMPAIGN', campaign)
    },
    changeTempCampaignsProductId({ commit }, productId) {
      commit('CHANGE_TEMP_CAMPAIGNS_PRODUCT_ID', productId)
    },
    duplicateFromArchive({ getters, dispatch }, { turn, productId }) {
      getters.teamArchivedCampaigns
        .filter(campaign => campaign.turn === turn && campaign.productId === productId)
        .forEach(campaign => dispatch('duplicateCampaign', campaign))
    },
    async duplicateCampaign({ getters, commit }, campaign) {
     /* try {
        const { data } = await api.campaign.purchase(_.pick(campaign, ['adTypeId', 'dayTimes', 'locationIds', 'productId']))
        commit('ADD_CAMPAIGN', data)
        this.$toast.success(`Campaign has been duplicated and purchased!`, { timeout: 1500 });
      } catch (e) {
        this.showError(e)
      }*/

       commit('ADD_CAMPAIGN', {
         ..._.pick(campaign, ['adTypeId', 'dayTimes', 'locationIds', 'productId']),
         isTemp: true,
         id: uid(),
         turn: getters.activeGame.turn,
         createdAt: new Date(),
       })
    },

    SOCKET_TEAM_CAMPAIGN_NEW({ commit, getters, dispatch }, campaign) {
      dispatch('addTeamMoney', -campaign.price)
      dispatch('changeTeamAds', campaign.adCount)
      if (getters.me.id !== campaign.lastUserId) {
        commit('ADD_CAMPAIGN', campaign)
      }
    },
    SOCKET_TEAM_CAMPAIGN_UPDATE({ commit, dispatch }, campaign) {
      dispatch('addTeamMoney', campaign.moneyChange)
      dispatch('changeTeamAds', campaign.adCountChange)
      commit('UPDATE_CAMPAIGN', campaign.campaign)
      dispatch('fetchCampaigns')

    },
    SOCKET_TEAM_CAMPAIGN_DELETE({ commit, dispatch }, campaign) {
      dispatch('addTeamMoney', campaign.moneyChange)
      dispatch('changeTeamAds', campaign.adCountChange)
      commit('DELETE_CAMPAIGN', campaign.id)
    },
    SOCKET_TEAM_CAMPAIGN_LOCK({ commit, dispatch }, campaign) {
      dispatch('fetchCampaigns')
      //commit('LOCK_CAMPAIGN', campaign)
    },
    SOCKET_TEAM_CAMPAIGN_UNLOCK({ commit, dispatch }, campaign) {
      commit('UNLOCK_CAMPAIGN', campaign)
    },
  },
  mutations: {
    SET_CAMPAIGNS(state, data) {
      state.campaigns = data || []
    },
    SET_ALL_GAME_CAMPAIGNS(state, data) {
      state.allGameCampaigns = data || []
    },
    SET_ARCHIVED_CAMPAIGNS(state, data) {
      state.archivedCampaigns = data || []
    },
    CAMPAIGNS_NEW_ROUND(state, turn) {
      state.tempCampaigns = state.tempCampaigns.map(campaign => ({
        ...campaign,
        turn,
      }))
      state.archivedCampaigns = [...state.archivedCampaigns, ...state.campaigns]
      state.campaigns = []
    },
    ADD_CAMPAIGN(state, campaign) {
      const source = campaign.isTemp ? state.tempCampaigns : state.campaigns
      source.push(campaign)
    },
    UPDATE_CAMPAIGN(state, campaign) {
      const source = campaign.isTemp ? 'tempCampaigns' : 'campaigns'
      state[source] = state[source].map(item => {
        if (item.id === campaign.id) {
          return {
            ...item,
            ...campaign
          }
        }
        return item
      })
    },
    UNLOCK_CAMPAIGN(state, campaign) {
      state["campaigns"] = state["campaigns"].map(item => {
        if (item.id === campaign) {
          var docasne = item;
          docasne.lockUser = null;
          return {
            ...item,
            ...docasne
          }
        }
        return item
      })
    },
    CHANGE_TEMP_CAMPAIGNS_PRODUCT_ID(state, { productId, oldProductId }) {
      state.tempCampaigns = state.tempCampaigns.map(campaign => ({
        ...campaign,
        productId: campaign.productId === oldProductId ? productId : campaign.productId,
      }))
    },
    DELETE_CAMPAIGN(state, id) {
      state.campaigns = state.campaigns.filter(campaign => campaign.id !== id)
    },
    DELETE_TEMP_CAMPAIGN(state, id) {
      state.tempCampaigns = state.tempCampaigns.filter(campaign => campaign.id !== id)
    },
    LOCK_CAMPAIGN(state, campaign) {
      const source = "campaigns";

      state[source] = state[source].map(item => {
        if (item.id === campaign.id) {
          console.log("test");
        }
      });
    }
  },
}
